import { products } from './products';

const menu = [
  {
    id: 1,
    title: 'Roasted Chicken',
    category: 'Lunch & Dinner',
    price: `$ 30`,
    model: products.find(({ id }) => id === 'chicken-plate'),
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.`,
    rating: 4.7,
  },
  {
    id: 2,
    title: 'Burger & French Fries',
    category: 'Lunch & Dinner',
    price: `$ 15`,
    model: products.find(({ id }) => id === 'burger'),
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.`,
    rating: 4.7,
  },
  {
    id: 3,
    title: 'Lemon Meringue Pie',
    category: 'Sweets',
    price: `$ 25`,
    model: products.find(({ id }) => id === 'LemonMeringuePie'),
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.`,
    rating: 4.7,
  },
  {
    id: 4,
    title: 'Cake',
    category: 'Sweets',
    price: `$ 40`,
    model: products.find(({ id }) => id === 'cake'),
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.`,
    rating: 4.7,
  },
  {
    id: 5,
    title: 'Fast food',
    category: 'Fast Food',
    price: `$ 40`,
    model: products.find(({ id }) => id === 'fast-food'),
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.`,
    rating: 4.7,
  }
]
export default menu
